module.exports = __webpack_public_path__ + "front/img/info.4db3efdf.png";